export var KubitProgressBarVariantType;
(function (KubitProgressBarVariantType) {
    KubitProgressBarVariantType["LINEAR_REGULAR"] = "LINEAR_REGULAR";
    KubitProgressBarVariantType["LINEAR_EMBEDDED"] = "LINEAR_EMBEDDED";
    KubitProgressBarVariantType["SEGMENTED"] = "SEGMENTED";
    KubitProgressBarVariantType["PROGRESS_CHART"] = "PROGRESS_CHART";
})(KubitProgressBarVariantType || (KubitProgressBarVariantType = {}));
export var KubitProgressBarSizeType;
(function (KubitProgressBarSizeType) {
    KubitProgressBarSizeType["DEFAULT"] = "DEFAULT";
})(KubitProgressBarSizeType || (KubitProgressBarSizeType = {}));
//# sourceMappingURL=variants.js.map